"use client";

import React from 'react';

const Testimonials = () => (
    <>
  <section className="py-12 sm:py-16 lg:py-20">
    <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      {/* Heading */}
      <div className="text-center">
       
        <h2 className="mt-4 text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl font-pj">
          Our Clients Love It
        </h2>
      </div>

      {/* Testimonials grid */}
      <div className="relative mt-10 md:mt-24">
        {/* Glow background */}
        <div className="absolute -inset-x-1 inset-y-16 md:-inset-x-2 md:-inset-y-6">
          <div
            className="w-full h-full max-w-5xl mx-auto rounded-3xl opacity-30 blur-lg"
            style={{
              background:
                'linear-gradient(90deg,#44ff9a -0.55%,#44b0ff 22.86%,#8b44ff 48.36%,#ff6644 73.33%,#ebff70 99.34%)',
            }}
          />
        </div>

        <div className="relative grid max-w-lg grid-cols-1 gap-6 mx-auto md:max-w-none lg:gap-10 md:grid-cols-3">
          {/* Card 1 */}
          <div className="flex flex-col overflow-hidden shadow-xl">
            <div className="flex flex-col justify-between flex-1 p-6 bg-white lg:py-8 lg:px-7">
              {/* Stars */}
              <div className="flex items-center">
                {Array.from({ length: 5 }).map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-[#FDB241]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="flex-1 mt-8">
                <p className="text-lg leading-relaxed text-gray-900 font-pj">
                  “SmartMetrics rebuilt our lead routing stack. Since switching off Zapier, the flow just runs in the background and our automation spend has dropped to a fraction of what it was. Great work!”
                </p>
              </blockquote>

              {/* Author */}
              <div className="mt-8">
                <p className="text-base font-bold text-gray-900 font-pj">
                  Maya K.
                </p>
                <p className="text-sm text-gray-600 font-pj">
                  B2B SaaS
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="flex flex-col overflow-hidden shadow-xl">
            <div className="flex flex-col justify-between flex-1 p-6 bg-white lg:py-8 lg:px-7">
              <div className="flex items-center">
                {Array.from({ length: 5 }).map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-[#FDB241]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <blockquote className="flex-1 mt-8">
                <p className="text-lg leading-relaxed text-gray-900 font-pj">
                  “We yanked our Shopify order sync off Zapier and let this team handle our integration. They had it live the same day!”
                </p>
              </blockquote>

              <div className="mt-8">
                <p className="text-base font-bold text-gray-900 font-pj">
                  Kevin B.
                </p>
                <p className="text-sm text-gray-600 font-pj">
                  E-commerce
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="flex flex-col overflow-hidden shadow-xl">
            <div className="flex flex-col justify-between flex-1 p-6 bg-white lg:py-8 lg:px-7">
              <div className="flex items-center">
                {Array.from({ length: 5 }).map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-[#FDB241]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <blockquote className="flex-1 mt-8">
                <p className="text-lg leading-relaxed text-gray-900 font-pj">
                  “We handle automations for a bunch of clients, and SM set up all our webhooks for one flat fee. Now we don't have to stress about bills anymore.
                </p>
              </blockquote>

              <div className="mt-8">
                <p className="text-base font-bold text-gray-900 font-pj">
                  Laura C.
                </p>
                <p className="text-sm text-gray-600 font-pj">
                  Marketing Agency
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="py-12 bg-white sm:py-16 lg:py-20">
  <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="text-center lg:flex lg:items-center lg:justify-between lg:text-left">
          <h2 className="max-w-xl mx-auto text-4xl font-bold text-gray-900 lg:mx-0 font-pj lg:pr-8 xl:pr-0">Start saving today - book your integration</h2>

          <div className="flex-shrink-0 mt-8 sm:flex sm:items-center sm:justify-center lg:mt-0 lg:justify-end sm:space-x-5">

              <div className="relative inline-flex w-full mt-5 group sm:w-auto sm:mt-0">
                  <div
                      className="absolute duration-1000 rotate-180 transitiona-all opacity-70 -inset-px rounded-xl blur-lg filter group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200"
                      style={{ background: 'linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)' }}
                  ></div>

                  <a
                      href="#"
                      title=""
                      onClick={(e) => {
                        e.preventDefault();
                        const calculatorSection = document.querySelector('section[id="cta"]');
                        calculatorSection?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="
                          relative
                          inline-flex
                          items-center
                          justify-center
                          w-full
                          px-6
                          py-3
                          text-base
                          font-bold
                          text-white
                          transition-all
                          duration-200
                          bg-gray-900
                          border-2 border-transparent
                          lg:w-auto
                          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900
                          font-pj
                          hover:bg-opacity-90
                          rounded-xl
                      "
                      role="button"
                  >
                      Get Started
                  </a>
              </div>
          </div>
      </div>
  </div>
</section>
</>
);

export default Testimonials;
